import { VlogSectionHeading, VlogVideoCard } from "@modules/study/common/vlog";
import { Grid } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";

const links = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Vlog",
    link: "/vlog",
  },
];

export const VlogTagArchive = ({ videoList }) => {
  const router = useRouter();
  const { slug } = router.query;

  const [paginate, setPaginate] = useState({
    currentPage: videoList.currentPage,
    limit: videoList.limit,
    page_total: videoList.page_total,
    total: videoList.total,
  });

  useEffect(() => {
    if (videoList.currentPage) {
      setPaginate((prev) => ({
        ...prev,
        currentPage: videoList.currentPage,
      }));
    }
  }, [videoList.currentPage]);

  const paginationHandler = (e, page) => {
    e.preventDefault();
    router.push(`/vlog/tag/${slug}?limit=20&page=${page}`);
  };

  return (
    <Fragment>
      <VlogSectionHeading
        links={links}
        title={`Tag Archive: ${videoList?.searchHead?.title}`}
        description={`${videoList?.searchHead?.metaSummary}`}
      />
      <section>
        <div className="container">
          <Grid container spacing={4}>
            {videoList &&
              videoList?.results?.length > 0 &&
              videoList?.results?.map((item, i) => (
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12} key={i}>
                  <VlogVideoCard item={item} />
                </Grid>
              ))}
          </Grid>
          {paginate && paginate.total > paginate.limit && (
            <PaginationComponent
              paginate={paginate}
              paginationHandler={paginationHandler}
            />
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default VlogTagArchive;
